module.exports = __webpack_public_path__ + "static/media/house3.a08cfa6d.png";